import * as React from 'react';
import { colors } from '../constants';

interface IProps {
    className?: string;
    onClick?(event: React.MouseEvent<SVGSVGElement, MouseEvent>): void;
}

export const BaseCross: React.FC<IProps> = ({ className, onClick }) => (
    <svg
        className={className}
        fill={colors.greenDark}
        onClick={onClick}
        viewBox="0 0 37 37"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g id="Page-1" stroke="none" strokeWidth="1">
            <g id="stap-2-1" transform="translate(-90.000000, -748.000000)">
                <g
                    id="iconmonstr-x-mark-1"
                    transform="translate(90.000000, 748.000000)"
                >
                    <polygon
                        id="Path"
                        points="37 31.1231667 24.1810417 18.467625 36.8227083 5.69954167 31.1231667 0 18.463 12.8235833 5.65175 0.177291667 0 5.82904167 12.8282083 18.532375 0.177291667 31.34825 5.82904167 37 18.52775 24.1764167 31.3004583 36.8227083"
                    />
                </g>
            </g>
        </g>
    </svg>
);
